<template>
  <li v-if="value" class="octadesk-chat-message-item">
    <span class="octadesk-app-join-room">
      <span>
        {{
          $t('conversation.agent', { name: value.displayName || value.name })
        }}
      </span>
    </span>
  </li>
</template>

<script>
  export default {
    props: ['value']
  }
</script>

<style></style>
